<div class="access-denied-container">
    <h1>Not Found</h1>
    <p>The page you are looking for was not found.</p>
    <a [routerLink]="dashboardUrl">Go to Dashboard</a>
</div>
